import React from 'react';
import { useEmployeeDashboard } from '../../hooks/useDashboard';
import { Card } from '../../components/common/Card';
import { Icons } from '../../components/common/Icons';
import { formatDate } from '../../utils/helpers';
import './MyTimesheetStats.css';

export function MyTimesheetStats() {
  const { data, isLoading, error } = useEmployeeDashboard();

  if (isLoading) {
    return null; // No loading animation
  }

  if (error || !data) {
    return null; // Silently fail - don't block the page
  }

  const statCards = [
    {
      title: 'Hours This Week',
      value: data.hoursThisWeek,
      icon: <Icons.Clock />,
      color: '#3b82f6',
    },
    {
      title: 'Days Missing',
      value: data.daysMissing,
      icon: <Icons.AlertCircle />,
      color: data.daysMissing > 0 ? '#ef4444' : '#10b981',
    },
    {
      title: 'Pending',
      value: data.pendingTimesheets,
      icon: <Icons.History />,
      color: '#f59e0b',
    },
    {
      title: 'Approved',
      value: data.approvedTimesheets,
      icon: <Icons.CheckCircle />,
      color: '#8b5cf6',
    },
  ];

  return (
    <div className="my-timesheet-stats">
      <div className="stats-header">
        <h3>My Timesheet Overview</h3>
        <span className="period-badge">
          Period: {formatDate(data.periodStart)} - {formatDate(data.periodEnd)}
        </span>
      </div>
      
      <div className="stats-grid">
        {statCards.map((stat, index) => (
          <Card key={index} className="stat-card mini" hoverable>
            <div className="stat-card-content">
              <div className="stat-icon" style={{ backgroundColor: `${stat.color}15`, color: stat.color }}>
                {stat.icon}
              </div>
              <div className="stat-info">
                <span className="stat-title">{stat.title}</span>
                <span className="stat-value">{stat.value}</span>
              </div>
            </div>
          </Card>
        ))}
      </div>

      {/* Progress bar */}
      <div className="weekly-progress-bar">
        <div className="progress-header">
          <span>Weekly Progress</span>
          <span className="progress-text">{data.hoursThisWeek}h / 40h</span>
        </div>
        <div className="progress-track">
          <div 
            className="progress-fill" 
            style={{ width: `${Math.min((data.hoursThisWeek / 40) * 100, 100)}%` }}
          />
        </div>
      </div>
    </div>
  );
}

export default MyTimesheetStats;
